export default __webpack_public_path__ + "static/media/hero-hike.2767a1ec.png";